<template>
  <div>
    <ed-modal
      :title="'Mensagem Email :: ' + formData.id"
      :modal="showFormMsg"
      width="95%"
      :isModal="false"
    >
      <div slot="modal-content">
        <span v-html="formData.mensagem"  />
      </div>
    </ed-modal>

    <ed-table
      :onSearch="getLog"
      :onFilter="getLog"
      :onRegister="onRegister ? onRegister : null"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
      :disabledConfigCell="disabledConfigCell"
      :filterBadge="filterBadge"
      disableCheckAll
    >
      <div slot="table-filter-content">
        <ed-form
          :data="formFilter"
          :config="config"
          :response="response"
          :itens="filterItems"
        />
      </div>
    </ed-table>
  </div>
</template>

<script>
import EdTable from "common/table";
import EdForm from "common/form";
import EdModal from "common/modal";
import Rest from "common/rest";
import FormItems from "./_form/filters";

export default {
  name: "exame",
  components: { EdTable, EdModal, EdForm },
  mixins: [Rest],
  props: {
    point_id: {
      type: [Number, String],
      default: function () {
        return null;
      },
    },
    point_type: {
      type: [String],
      default: function () {
        return null;
      },
    },
    filter: {
      type: [Object],
      default: function () {
        return {};
      },
    },
    onRegister: {
      type: [Function],
      default: null,
    },
  },
  watch: {
    point_id() {
      this.getLog();
    },
    point_type() {
      this.formatarCabecalho();
      this.getLog();
    },
    '$root.$session.event'(){

      switch (this.$root.$session.event) {
        case 'DisparoNotifyEvent':
        case 'LogEmailNotifyEvent':
          this.getLog();
          this.$root.$session.event = null;
          break;
      
        default:
          break;
      }
    }
  },
  
  data() {
    return {
      config: {
        click: {},
        list: {},
        loading: {},
      },
      pagination: {},
      response: {},
      formData: {
        id: 0,
        mensagem: null,
      },
      formFilter: {
        created_at: [],
        tabela: this.tabela,
        registro: this.registro,
      },
      tableHead: [
        {
          key: "id",
          sortable: true,
          label: " Nº Envio",
        },
        {
          key: "point",
          sortable: true,
          label: "Identificação",
        },
        {
          key: "remetente",
          sortable: true,
          label: "Remetente",
        },
        {
          key: "destinatario",
          sortable: true,
          label: "Destinatário",
        },
        {
          key: "status",
          sortable: true,
          show_status: true,
          label: "Status",
        },
        {
          key: "created_at",
          sortable: true,
          show_user: true,
          label: "Atualização",
        },
      ],
      tableData: [],
      filterItems: [],
      loadingTable: false,
      showFormMsg: false,
      disabledConfigCell: true,
      filterBadge: 0,
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {
    this.formatarCabecalho();
  },

  mounted: function () {
    this.getLog();
    this.filterItems = FormItems;
  },

  methods: {
    formatarCabecalho() {
      switch (this.point_type) {
        case "consulta":
          this.tableHead[1].label = "Consulta";
          break;

        case "empresa":
          this.tableHead[1].label = "Empresa";
          break;

        case "funcionario":
          this.tableHead[1].label = "Funcionário";
          break;

        case "esocial-lote":
          this.tableHead[1].label = "Lote";
          break;
      }
    },

    formatarPoint(data) {
      switch (this.point_type) {
        
        case "consulta":
          return data.id_con;
          break;

        case "funcionario":
          return (
            "<span>" +
            data.nome +
            "</span>" +
            (data.empresa ? "<br><span>" + data.empresa.nome + "</span>" : "")
          );
          break;

        case "esocial-lote":
          return data.lote;
          break;

        default:
          return data.nome;
          break;
      }
    },

    onMensagem(data) {
      this.formData = {
      	id:data.id,
      	mensagem:data.mensagem
      }
      //this.showFormMsg = !this.showFormMsg;
      this.open("log/email/html/" + this.formData.id);
    },

    onError(data) {
      this.formData = {
        id: data.id,
        mensagem: data.obs,
      };
      this.showFormMsg = !this.showFormMsg;
    },

    getLog(_search, _page, _pagination) {
      if (!this.point_type) return;

      this.loadingTable = true;
      this.disabledConfigCell = true;
      this.response = {};

      if (!this.formFilter.created_at) {
        this.formFilter.created_at = [];
      }

      if (this.formFilter.created_at.length < 2) {
        var hoje = this.toDate(null, true),
          ontem = this.toDate(this.addDate(-1, null, "y"), true),
          amanha = this.toDate(this.addDate(1, null, "D"), true);

        this.formFilter.created_at.push(ontem, amanha);
      }

      this.filterBadge = this.formFilter.created_at.length > 0 ? 1 : 0;
      var filters = Object.assign(this.filter, this.formFilter);

      this.get(
        "log/email/" +
          this.point_type +
          (this.point_id ? "/" + this.point_id : ""),
        {
          search: _search,
          page: _page,
          pagination: _pagination,
          filter: filters,
        }
      ).then((result) => {
        result = result[0];
        this.response = result;

        var data = [],
          tableData = [],
          pagination = {};

        if (result.status == 200) {
          (data = result.data.data),
            (tableData = []),
            (pagination = result.data);

          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              remetente: data[i].remetente,
              destinatario: data[i].destinatario
                ? data[i].destinatario.split(";").join("<br>")
                : "---",
              point: data[i].point ? this.formatarPoint(data[i].point) : "---",
              status: data[i].obs ? data[i].obs : "",
              created_at: this.toDate(data[i].created_at),
              _data: data[i],
              options: {},
              buttons: [],
            };

            if (data[i].mensagem) {
              this.disabledConfigCell = false;
              item.buttons.push({
                icon: "fa fa-file-text-o",
                color: "success",
                title: "Visualizar Mensagem",
                click: this.onMensagem,
              });
            }

            if (data[i].obs) {
              this.disabledConfigCell = false;
              item.buttons.push({
                icon: "fa fa-window-close",
                color: "danger",
                title: "Visualizar Erro",
                click: this.onError,
              });
            }
            tableData.push(item);
          }
        }

        this.pagination = pagination;
        this.tableData = tableData;
        this.loadingTable = false;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// index.vue?e54541a0